import { useState } from 'react'

interface MediaItem {
	type: 'image' | 'video'
	url: string
	largeUrl?: string
	variantName?: string
}

interface CosmeticImagesProps {
	media: MediaItem[]
	onMediaClick: (variantName: string) => void
	onMediaHover: (variantName: string) => void
	selectedVariant?: string
}

export function CosmeticImages({
	media,
	onMediaClick,
	onMediaHover,
	selectedVariant,
}: CosmeticImagesProps) {
	return (
		<div className="mt-8">
			<div className="flex flex-wrap gap-4">
				{media.map((item, index) => (
					<div
						key={index}
						className={`aspect-square cursor-pointer overflow-hidden rounded-lg shadow-md transition-shadow hover:shadow-lg ${
							selectedVariant === item.variantName ? 'ring-2 ring-blue-500' : ''
						}`}
						onClick={() => onMediaClick(item.variantName || '')}
						onMouseEnter={() => onMediaHover(item.variantName || '')}
						onMouseLeave={() => onMediaHover('')}
					>
						<img
							src={item.url}
							alt={item.variantName}
							className="h-full max-w-36 object-cover transition-transform hover:scale-105"
							onMouseOver={e => {
								if (item.largeUrl) {
									e.currentTarget.src = item.largeUrl
								}
							}}
							onMouseOut={e => {
								e.currentTarget.src = item.url
							}}
						/>
					</div>
				))}
			</div>
		</div>
	)
}
